<script lang="ts" setup>
// TODO: Move this component to nuxt base layer
import logoLight from '~/assets/img/wmt-light.svg?component'
import logoDark from '~/assets/img/wmt-dark.svg?component'
import { Target } from '~/enums/target'

interface Props {
  isDark?: boolean
}

const props = defineProps<Props>()
const WMTLogo = computed<Component>(() => (props.isDark ? logoLight : logoDark))
</script>

<template>
  <a
    href="https://wmt.digital/"
    :target="Target.Blank"
    rel="noopener"
    class="footer-powered"
  >
    <UIExternalLinkWarning />
    <span class="footer-powered__label">Powered by</span>
    <span class="sr-only">WMT Digital</span>
    <WMTLogo class="footer-powered__logo" />
  </a>
</template>

<style lang="scss">
.footer-powered {
  @apply flex items-center gap-2;

  &__label {
    @apply text-[12px] text-white/70 whitespace-nowrap;
  }

  &__logo {
    @apply w-[75px];
  }
}
</style>
